module.exports = __webpack_public_path__ + "img/logo-2.71a0e7ba.svg";